import React from 'react';
import Services from '../components/Services';

const ServicesPage = () => {
  return (
    <div>
      <Services />
    </div>
  );
};

export default ServicesPage;





